//import VirtualGuardHome from "@/components/virtualGuard/VirtualGuardHome.vue";

import GuardDashboard from "../../views/GuardDashboard.vue";




export default [
  {path: '/', component: GuardDashboard, name: 'root'}
]

